import { render, staticRenderFns } from "./multiple-trigger.vue?vue&type=template&id=8fdccc52&scoped=true&"
import script from "./multiple-trigger.vue?vue&type=script&lang=js&"
export * from "./multiple-trigger.vue?vue&type=script&lang=js&"
import style0 from "./multiple-trigger.vue?vue&type=style&index=0&id=8fdccc52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdccc52",
  null
  
)

export default component.exports